//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  export default {
    name: 'Logic',
    data () {
      return {
        ifOver: false, // 文本是否超出三行，默认否
        unfold: false, // 文本是否是展开状态 content
        receiver:[
        ],
        logisticsList: [
          {
            remark: '暂时未查询到物流，请您耐心等候',
            acceptTime: '',
             acceptAddress:''
          },
        ],
        receivertelephone:this.$route.query.receivertelephone?this.$route.query.receivertelephone:'',
        orderid:this.$route.query.id ? this.$route.query.id : '',
      }
    },
//    http://prehzyh5.51bjhzy.com/logistics?receivertelephone=15010493139
    created() {
      this.$store.state.userInfo.sessionId = 'haozhongyi';
      document.title = "物流信息";
      this.query();
    },
    methods: {
      getDetails(e){
        console.log("范德萨范德萨")
        this.$doRequest("api/sweepSizeOrder/scanOrder?waybillCode="+e,null,res => {
          if(res.parameters.length>0){
            this.logisticsList=res.parameters.reverse();
          }else{
            this.logisticsList=[
              {
                remark: '暂时未查询到物流，请您耐心等候',
                acceptTime: '',
                acceptAddress:''
              },
              {
                remark: '运单已生成，正在等待揽收',
                acceptTime: '',
                acceptAddress:''
              },
            ]
          }

            console.log(res);
        });
      },
      query(){
        if( this.orderid && this.orderid!=''){
          let params = {
            orderid: this.orderid,
          }
          this.$doRequest("api/orderRemark/getOrderRemarkByKey", params,res => {
            this.receiver=res;
            if(res.length>0){
              this.getDetails(res[0].couriernumber);
            }else{
              this.logisticsList=[
                {
                  remark: '暂时未查询到物流，请您耐心等候',
                  opeTime: '',
                  acceptAddress:''
                },
                {
                  remark: '正在为您发货，请耐心等待',
                  opeTime: '',
                  acceptAddress:''
                },
              ]
            }

          })
//          根据订单ID查询运单号
        }else{
          let params = {
            receivertelephone: this.receivertelephone,
          }
          this.$doRequest("api/orderRemark/getOrderRemarkByKey", params,res => {
            res.reverse();
            if(
              res[0].couriernumber!=''&&res[0].couriernumber!=null
            ){
              res.reverse();
              this.receiver=res;
              this.getDetails(res[0].couriernumber);
            }else{
              this.$toastMsg("暂无物流信息");
              return
            }
          });
        }

      },
      copyapp(text) {
        var textareaEl = document.createElement('textarea');
        textareaEl.setAttribute('readonly', 'readonly'); // 防止手机上弹出软键盘
        textareaEl.value = text;
        document.body.appendChild(textareaEl);
        textareaEl.select();
        var res = document.execCommand('copy');
        document.body.removeChild(textareaEl);
        this.$toastMsg("复制成功");
        return res;
      },
    },
    /**
     * 加载时执行
     */
    mounted: function () {
      // 判断是否显示展开收起按钮
      this.ifOver = this.$refs.spanBox.offsetHeight > this.$refs.textBox.offsetHeight;

    }
  }



// WEBPACK FOOTER //
// ./src/views/logistics/index.vue